/**
 * 新增 编辑
 * @author 3173
 * @description  新增/编辑
 * @Date  2020/9/28
 */
import React, { Component } from 'react';
import { component_tool, framework_tool, utils_tool } from '@/tool'

let { WizAvatarUpload, ossFileUtils, WizFileUpload, WizOssUpload } = framework_tool
import { Form, Card, Row, Col, Input, Button, Table, Select, Descriptions, Space, Upload, Modal, Layout,Divider } from "antd";
import UploadVideoToPic from '../../../../common/uploadVideoToPic'
let {
  WizButton,
  WizSelect,
  WizTooltip,
  WizInput,
  WizIcon,
  WizUpload,
  WizDatePicker,
  WizRow,
  WizCol,
  WizCard,
  WizRadio,
  WizDivider,
  WizCheckbox,
  WizInputNumber,
  Wizmessage,
  WizAlert,
  WizTreeSelect,
  WizLayout,
  WizTabs,
  WizDataTable,
  WizSpin,
  WizModal,
  WizTable,
  WizMenu,
  WizDropdown
} = component_tool;
let WizForm = Form
let Item = Form.Item
const WizItem = WizMenu.Item
let { TabPane } = WizTabs
const { TextArea } = WizInput;
let Option = WizSelect.Option
let { Storage, getPageData } = utils_tool;
import moment from 'moment'
import BigAvatarUpload from '../../../../common/bigAvatarUpload/index'
import '@/styles/containers/proKnowledge/knowledgeBaseList/style.less'
import { WizTableForm, WizClassifySelectRe, WizAuthority, WizDataAuthSelect, WizBraftEditorPlus } from '../../../../common'
const labelConfig = WizTableForm.Config.label(this, { apiParams: { type: 6, name: '产品知识库标签' } })
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1 } })
const categoryConfig = WizTableForm.Config.categoryInfo(this, {apiParams: {type: 18, state: 1}})
const brandConfig = WizTableForm.Config.organizationBrandNode(this, {
  apiParams: {
    state: 1,
    organizationNodeCategory: ["2"]
  }
})


/**
 * 此组件没有继承WizComponent，因为需要使用Form.create()该组件
 * 继承WizComponent后 form的部分功能缺失了
 * 初步怀疑是WizComponent修改了生命周期的钩子导致的
 * by mll 2020-2-4
 */

class KnowledgeBaseForm extends Component {

  constructor(props) {
    super(props);
    let { initialValue, proKnowledgeTypeInfo, knowledgeTypeId } = props;
    this.state = {
      fileList: [], //文件列表
      imgValue: [], //图片
      coverUse: 1,//是否作为封面图使用
      authorType: initialValue.authorType ? initialValue.authorType : 1, //作者类型 默认为内部
      changeFileIdList: [], //文件ids
      scheduleModalVisible: false,
      studyModalVisible: false,
      videoModalVisible: false,
      trickModalVisible: false,
      programModalVisible:false,
      modalKey:undefined,
      timeStamp:new Date().getTime(),
      selectedRows:[],
      activeKey:"1"
    }
    this.initialValue = initialValue ? initialValue : {};
    this.knowledgeTypeId = knowledgeTypeId
    this.clearWizCallBack = [];
  }

  /**
 * 处理表单提交事件
 */
  _onSubmit(flag) {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let { onSubmit } = this.props
        onSubmit && onSubmit(values, {state:flag})
      }
    });
  }

  _getHeader() {
    let btns = !this.initialValue.id?
 [<WizButton htmlType="submit" onClick={e => this._onSubmit(1)}>
    保存为草稿
  </WizButton>,
  <WizButton className="btn-info" htmlType="submit" onClick={e => this._onSubmit(2)}>
    保存并发布
  </WizButton>] : <WizButton className="btn-info" htmlType="submit" onClick={e => this._onSubmit(this.initialValue.state)}>
    保存
  </WizButton>
    return  <WizRow className='knowledge-div-button' gutter={[8, 16]}>
    <WizCol>
      <WizRow className='knowledge-row' align={'middle'} justify={'center'}>
        <WizCol offset={20}>
          <WizButton.WizGroup className={'knowledge-group-button'}>
            {btns}
          </WizButton.WizGroup>
        </WizCol>
      </WizRow>
    </WizCol>
  </WizRow>
  }

  /**上传校验 */
  _ossBeforeUpload(file, fileList, _onRemove) {
    let result = true;
    if (this.state.changeFileIdList && this.state.changeFileIdList.length) {
      wizNotice.error('只能上传一个文件');
      result = false;
    }
    return result;
  }

  // 获取组件返回值
  handleUploadVideoOnChange = values => {
    const {fileId,contentText,checkUse} = values
    if(checkUse){
      this.props.form.setFieldsValue({ img: fileId });
    }
  };


  /**
   * 重置表单
   */
  handleReset = (type, option) => {
    WizModal.confirm({
      title: "注意",
      content:"更换知识类型后，当前页面的所有已录入的内容将会重置，是否确认？",
      onOk: () => {
        this.props.getProKnowledgeType(type);
        this.props.clearBusinessListInfo();
      },
      onCancel:()=>{
        this.props.form.setFieldsValue({proKnowledgeTypeId:this.knowledgeTypeId});
      },
    });
  };

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }

  _getModule(){
    let dict =[
      { code: 0, codeName: "销售" },
      { code: 1, codeName: "售后服务" },
      { code: 2, codeName: "售后技术" },
      { code: 3, codeName: "诚新二手车" },
      { code: 4, codeName: "校企合作" },
      { code: 5, codeName: "集团销售" },
      { code: 9, codeName: "跨业务块" },
    ]
    let optionInfoList =[]
    dict.forEach(e=>{
      let brandOptionInfo = <Option value={e.code}>{e.codeName}</Option>
      optionInfoList.push(brandOptionInfo);
    })
    return <WizSelect placeholder="请选择功能块">
            {optionInfoList}
          </WizSelect>
  }

  _getLeftBody() {
    let leftForms = [];
    let user = Storage.getStorage('user') || {}
    let fullName = "";
    let personId = "";
    if (user.fullName && user.personId) {
      fullName = user.fullName
      personId = user.personId
    }
    const { getFieldDecorator } = this.props.form;
    const { proKnowledgeTypes, proKnowledgeTypeInfo } = this.props
    let propertyList = proKnowledgeTypeInfo.propertyList;
    let options = []
    if (proKnowledgeTypes && proKnowledgeTypes.length) {
      //补充当前知识类型选项
      let addFlag = true;
      proKnowledgeTypes.forEach(e => {
        let optionInfo = <Option value={e.id}>{e.title}</Option>
        options.push(optionInfo);
        if(e.id==this.initialValue.proKnowledgeTypeId){
          addFlag =false;
        }
      })
      if(addFlag){
        let optionInfo = <Option value={this.initialValue.proKnowledgeTypeId}>{this.initialValue.proKnowledgeTypeTitle}</Option>
        options.push(optionInfo);
      }
    }
    if (propertyList && propertyList?.length>0) {
      propertyList.forEach(element => {
        let input;
        let initInfo;
        let initRows;
        switch (element.code) {
          case "img": input =
            <BigAvatarUpload
              accept={'.jpg, .jpeg, .png, .bmp'}
              listType={'picture-card'}
              aspectRatio={400 / 207}
              beforeUpload={(file) => {
                let result = true;
                const isLt1M = file.size / 1024 / 1024 < 10;
                if (file.type.indexOf('image/') == -1) {
                  Wizmessage.error('只能上传图片类型,请重新选择!');
                  result = false;
                } else if (!isLt1M) {
                  Wizmessage.error('图片不得超过10M!');
                  result = false;
                }
                return result;
              }}
            />
            initInfo = (this.initialValue && this.initialValue.img) ? [
              { fileId: this.initialValue.img }
            ] : ''
            break;
          case "authorType":
            input = <WizRadio.Group onChange={(value) => {
              if (value.target.value == 2) {
                this.props.form.setFieldsValue({ author: undefined });
                this.props.form.setFieldsValue({ belongOrg: undefined });
              } else {
                this.props.form.setFieldsValue({ author: [] });
                this.props.form.setFieldsValue({ belongOrg: [] });
              }
              this.setState({ authorType: value.target.value })
            }}><WizRadio value={1}>内部</WizRadio><WizRadio value={2}>外部</WizRadio></WizRadio.Group>
            initInfo = this.state.authorType
            break;
          case "author":
            initRows = !this.initialValue.id && personId && fullName ? [{
              key: '1',
              personId: personId,
              fullName: fullName,
              id: personId
            }] : this.initialValue.id && this.initialValue.authorType==1? [
              {
                key: '2',
              personId: this.initialValue.authorId,
              fullName: this.initialValue.authorName,
              id: this.initialValue.authorId,
              }
            ] :[],
              initInfo = !this.initialValue.id ? personId : this.initialValue.id && this.initialValue.authorType==1 ?this.initialValue.authorId:this.initialValue.author,
              input = this.state.authorType == 1 ?
                <WizTableForm key='author' {...userConfig} selectType={"radio"} title="请选择作者" initRows={initRows} />
                :
                <WizInput key='author' maxlength={20} placeholder='请输入作者,最多输入20字' />
            break;
          case "authorIntro": input = <TextArea  maxLength={30} rows={2} placeholder="请输入作者介绍,最多输入30字" showCount />
            initInfo = this.initialValue.authorIntro
            break;
          case "belongOrg":
          initRows = this.initialValue.authorType==1 ?
          [{id:this.initialValue.belongOrgId,name:this.initialValue.belongOrgName}] :[]
          input = this.state.authorType == 1 ?
            <WizTableForm {...organizationConfig} selectType={"radio"} placeholder='请选择组织' title="请选择组织" initRows={initRows} />
            :
            <WizInput key='belongOrg' maxlength={20} placeholder='请输入组织,最多输入20字' />
            initInfo = this.initialValue.authorType==1 ? this.initialValue.belongOrgId:(this.initialValue.id ? this.initialValue.belongOrg:null)
            break;
          case "category":
          initInfo= this.initialValue.categoryIdList ? this.initialValue.categoryIdList : [],
          //initRows = this.initialValue.categoryObj ? this.initialValue.categoryObj : [],
          input =
          <WizClassifySelectRe
            returnKey={true}
            apiProps={{ type: 18, state: 1 ,categoryName:'产品知识',sceneType:125}}
            apiPath={"questionType/normalNodeList"}
            initSelects={this.initialValue.categoryObj ? this.initialValue.categoryObj : []}
            wizTreeSelectListProps={{
              itemProps: {
                icon: 'unordered-list',
                title: '知识分类',
                tips: '请勾选知识分类'
              },
              multiple: true,
              treeCheckable: false,
              checkable: true,
              showSelectList: true,
              treeProps: { checkStrictly: true },
            }}
            onClearWiz={this._onClearWiz.bind(this)}
          />
          //<WizTableForm {...categoryConfig}  title="请选择分类" onClearWiz={this._onClearWiz.bind(this)} initRows={initRows} />
            break;
          case "label":
          initInfo = this.initialValue.labelIdList ? this.initialValue.labelIdList:[]
          initRows = this.initialValue.labelObj ? this.initialValue.labelObj :[]
          input = <WizTableForm {...labelConfig} placeholder='请选择标签' title="请选择标签" onClearWiz={this._onClearWiz.bind(this)} initRows={initRows} />

          break;
          case "startTime": input = <WizDatePicker key='startTime' showTime placeholder="请选择生效时间" />
              initInfo = this.initialValue.effectiveTime && moment(this.initialValue.effectiveTime, 'YYYY-MM-DD HH:mm:ss') || null
            break;
          case "endTime": input = <WizDatePicker key='endTime' showTime placeholder="请选择失效时间" />
              initInfo = this.initialValue.failureTime && moment(this.initialValue.failureTime, 'YYYY-MM-DD HH:mm:ss') || null
            break;
          default:
            break
        }
        let wrapperCol = element.name=='封面' ? {xs:{ span: 24, offset: 0 },sm:{ span: 24, offset: 0}} : {xs:{ span: 4, offset: 0 },sm:{ span: 16, offset: 0}}
        let leftFormItem = <Item label={element.name=='封面'?"":element.name} 
        wrapperCol={wrapperCol}
        >
          {getFieldDecorator(element.code, {
            rules: element.code == 'authorIntro' || element.code == 'img' ? [{ required: false }] : [{ required: true, message: `${element.name} 不能为空`, }],
            initialValue: initInfo
          })(input)}
        </Item>
        leftForms.push(leftFormItem);
        if (element.code == 'belongOrg') {
          
          let brandItem = <Item label={"品牌"}>
            {getFieldDecorator("brandId", {
              rules: [{ required: true, message: `品牌 不能为空`, }],
              initialValue: this.initialValue.brandId,
            })(<WizTableForm {...brandConfig} selectType={"radio"} placeholder='请选择品牌' title="请选择品牌"  initRows={[{id:this.initialValue.brandId,name:this.initialValue.brandName}]}/>)}
          </Item>
          leftForms.push(brandItem);

          
          let moduleItem = <Item label={"功能块"}>
            {getFieldDecorator("module", {
              rules: [{ required: true, message: `功能块 不能为空`, }],
              initialValue: this.initialValue.module,
            })(this._getModule())}
          </Item>
          leftForms.push(moduleItem);


          let knowledgeType = <WizSelect
            placeholder="请选择知识类型"
            // onChange={(type, option) => this._handleTypeChange(type, option)}
            onChange={(type, option) => this.handleReset(type, option)}
          >
            {options}
          </WizSelect>
          let typeItem = <Item label={"知识类型"}>
            {getFieldDecorator("proKnowledgeTypeId", {
              rules: [{ required: true }],
              initialValue: this.knowledgeTypeId,
            })(knowledgeType)}
          </Item>
          leftForms.push(typeItem);
        }
      });
    }
    return leftForms
  }

  _getRightBody() {
    const { getFieldDecorator } = this.props.form;
    let { fileList, imgValue, coverUse } = this.state
    const { proKnowledgeTypeInfo } = this.props
    let items = [
      <Item label={"标题"} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
        {getFieldDecorator('title', {
          rules: [{ required: true, message: `标题 不能为空`, }],
          initialValue: this.initialValue.title,
        })(<WizInput maxlength={50} placeholder='请输入标题,最多输入50字' />)}
      </Item>,
      <Item label={"摘要"} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
        {getFieldDecorator('intro', {
          initialValue: this.initialValue.intro,
          rules: [{ required: false }],
        })(<WizInput maxlength={200} placeholder='请输入摘要,最多输入200字' />)}
      </Item>,

    ]
    let contentType = proKnowledgeTypeInfo.contentType;
    if (contentType && contentType.indexOf("1") != -1) {
      let item = <Item label={"知识"} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
        {getFieldDecorator('fileIdList', {
         // rules: [{ required: true, message: `知识 不能为空`, }],
          initialValue: this.initialValue.fileInfo ? this.initialValue.fileInfo:[],
        })(
          <UploadVideoToPic onChange={this.handleUploadVideoOnChange} value={this.initialValue.fileInfo} imgValue={imgValue} coverUse={coverUse}
          fileTypeStr = {proKnowledgeTypeInfo.fileTypeAccept}
          />
        )}
      </Item>
      items.push(item);
    }
    if (contentType && contentType.indexOf("2") != -1) {
      let item = <Item label="富文本" labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
        {getFieldDecorator('textContent', {
        //  rules: [{ required: true, message: '请输入富文本' }],
          initialValue: this.initialValue.textContent ? this.initialValue.textContent : proKnowledgeTypeInfo.textContent,
        })(<WizBraftEditorPlus links={[0, 1, 2, 3]} />)}
      </Item>;
      items.push(item);
    }
    return items
  }

  _highSet() {
    const { getFieldDecorator } = this.props.form;
    return [<Item label={"发布终端"} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
      {getFieldDecorator('releasePlatformList', {
        initialValue: this.initialValue.releasePlatformList ? this.initialValue.releasePlatformList : [1, 2, 3, 5, 6, 7],
        rules: [{ required: false }],
      })(<WizCheckbox.Group>
        <WizCheckbox value={1}>PC</WizCheckbox>
        <WizCheckbox value={2}>APP</WizCheckbox>
        <WizCheckbox value={3}>凯迪拉克IQ</WizCheckbox>
        {/* <WizCheckbox value={4}>小程序</WizCheckbox> */}
        <WizCheckbox value={5}>雪佛兰企微</WizCheckbox>
        <WizCheckbox value={6}>别克企微</WizCheckbox>
        <WizCheckbox value={7}>凯迪拉克企微</WizCheckbox>
      </WizCheckbox.Group>)}
    </Item>,
    <Item label={"添加水印"} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
      {getFieldDecorator('watermark', {
        initialValue: this.initialValue.watermark === 0 ? [this.initialValue.watermark] : [1],
        rules: [{ required: false }],
      })(<WizCheckbox.Group>
        <WizCheckbox value={1}></WizCheckbox>
      </WizCheckbox.Group>)}
    </Item>,
    <Item label={"是否允许下载"} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
      {getFieldDecorator('download', {
        initialValue: this.initialValue.download === 1 ? [this.initialValue.download] : [0],
        rules: [{ required: false }],
      })(<WizCheckbox.Group>
        <WizCheckbox value={1}></WizCheckbox>
      </WizCheckbox.Group>)}
    </Item>,
    <Item label={"点赞"} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
      {getFieldDecorator('switchLike', {
        initialValue: this.initialValue.switchLike === 0 ? this.initialValue.switchLike : 1,
        rules: [{ required: false }],
      })(<WizRadio.Group>
        <WizRadio value={1}>打开</WizRadio>
        <WizRadio value={0}>关闭</WizRadio>
      </WizRadio.Group>,)}
    </Item>,
    <Item label={"评论"} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
      {getFieldDecorator('switchComment', {
        initialValue: this.initialValue.switchComment === 0 ? this.initialValue.switchComment : 1,
        rules: [{ required: false }],
      })(<WizRadio.Group>
        <WizRadio value={1}>打开</WizRadio>
        <WizRadio value={0}>关闭</WizRadio>
      </WizRadio.Group>,)}
    </Item>,
    <Item label={"受众"} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
      {getFieldDecorator('authCmd', {
        initialValue: Object.assign({}, this.initialValue.authInfo),
        rules: [{ required: false }],
      })(<WizDataAuthSelect />)}
    </Item>
    ]
  }

  _getVersionListInfo() {
    let columns = [
      {
        title: "序号",
        name: "no",
        dataIndex: "no",
        tableItem: {},
      },
      {
        title: "标题",
        name: "title",
        dataIndex: "title",
        tableItem: {},
      },
      {
        title: "知识类型",
        name: "proKnowledgeType",
        dataIndex: "proKnowledgeType",
        tableItem: {},
      },
      {
        title: "创建人",
        name: "createBy",
        dataIndex: "createBy",
        tableItem: {},
      },
      {
        title: "版本号",
        name: "version",
        dataIndex: "version",
        tableItem: {},
      },
      {
        title: "创建时间",
        name: "createTime",
        dataIndex: "createTime",
        tableItem: {},
      },
    ]
    const dataItems = getPageData(this.props.versionListInfo);
    let dataTableProps = {
      loading: this.props.proKnowledgeLoading,
      columns,
      rowKey: 'id',
      dataItems: dataItems,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        this.props.getVersionList({ current: pageNum, size: pageSize })
      },
      showNum: false,
    }
    return <WizSpin tip={'加载中'} spinning={this.props.proKnowledgeLoading}>
      <div style={{marginBottom:'15px'}}><strong><font>当前版本</font><font style={{marginLeft:"20px"}}>{this.props.version ? this.props.version :"V1.0" } </font></strong></div>
      <WizDataTable key={'version_dataTable1'} {...dataTableProps} />
      <div className='pagination'>
        <WizDataTable.Pagination key={'version_dataTable2'} {...dataTableProps} />
      </div>
    </WizSpin>
  }

  _getChangeListInfo() {
    let columns = [
      {
        title: "序号",
        name: "no",
        dataIndex: "no",
        tableItem: {},
      },
      {
        title: "变更人",
        name: "fullName",
        dataIndex: "fullName",
        tableItem: {},
      },
      {
        title: "账号",
        name: "userName",
        dataIndex: "userName",
        tableItem: {},
      },
      {
        title: "变更时间",
        name: "time",
        dataIndex: "time",
        tableItem: {},
      },
    ]
    const dataItems = getPageData(this.props.changeListInfo);
    let dataTableProps = {
      loading: this.props.proKnowledgeLoading,
      columns,
      rowKey: 'id',
      dataItems: dataItems,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        this.props.getChangeList({ current: pageNum, size: pageSize })
      },
      showNum: false,
    }
    return <WizSpin tip={'加载中'} spinning={this.props.proKnowledgeLoading}>
      <div style={{marginBottom:'15px'}}><strong><font>当前版本</font><font style={{marginLeft:"20px"}}>{this.props.version ? this.props.version :"V1.0" } </font></strong></div>
      <WizDataTable key={'changeList_dataTable1'} {...dataTableProps} />
      <div className='pagination'>
        <WizDataTable.Pagination key={'changeList_dataTable2'} {...dataTableProps} />
      </div>
    </WizSpin>
  }

  handleMenuClick(e) {
    if (e.key == '5') {
      this.setState({ scheduleModalVisible: true ,modalKey:5})
    } else if (e.key == '4') {
      this.setState({ studyModalVisible: true,modalKey:4 })
    }else if (e.key == '3') {
      this.setState({ videoModalVisible: true,modalKey:3 })
    }else if (e.key == '2') {
      this.setState({ trickModalVisible: true,modalKey:2 })
    }else if (e.key == '1') {
      this.setState({ programModalVisible: true,modalKey:1 })
    }
  }

  onOk = () => {
    const { selectedRows,modalKey } = this.state
    if(!selectedRows.length) {
      wizNotice.warn('请选择一行数据')
      return
    }
    let sort = this.props.businessListInfo.length;
    let selectedRowsNew = [];
    let typeStr = ""
    if (modalKey === 5) {

    } else if (modalKey === 4) {

    }else if (modalKey === 3) {

    }else if (modalKey === 2) {

    }else if (modalKey === 1) {
      typeStr = "在线课程"
    }
    selectedRows.forEach(element=>{
      sort = sort+1;
      let elementNew = {entityId: element.id,sort,type:modalKey,typeStr,entityName:element.name}
      selectedRowsNew.push(elementNew);
    })
    this.props.addRow([...this.props.businessListInfo,...selectedRowsNew])
    this.setState({ programModalVisible: false,timeStamp: new Date().getTime(),selectedRows:[]})
  }

  // 弹出条件数据表格取消按钮
  onCancel = () => {
    this.setState({ programModalVisible: false,timeStamp: new Date().getTime(),selectedRows:[]})
  }

  // 弹出条件数据表格选择行
  onSelectedRows = selectedRows => {
    this.setState({ selectedRows })
  }

  _getModalInfo(){
    let {timeStamp,modalKey,programModalVisible} = this.state
    const {businessListInfo} = this.props
    let notInIds = [];
    businessListInfo && businessListInfo.forEach(e=>{
      if(e.type==modalKey){
        notInIds.push(e.entityId);
      }
    })
    let wizInfo = {}
    let visible = false;
    let title = ""
    if (modalKey === 5) {

    } else if (modalKey === 4) {

    }else if (modalKey === 3) {

    }else if (modalKey === 2) {

    }else if (modalKey === 1) {
      wizInfo = {...WizTableForm.Config.program(this, {apiParams: {notInIds,status:1,isPower:false}})}
      visible = programModalVisible
      title = "在线课程"
    }
    const modalProps = {
      key:modalKey+"-"+timeStamp,
      visible,
      width: 1000,
      onOk: this.onOk,
      onCancel: this.onCancel,
      style: { top: 30 }
    }
    return <WizModal { ...modalProps }> 
    <WizTableForm  showModal={false}  title={title} {...wizInfo}  onSelectedRows={ this.onSelectedRows } />
    </WizModal>
  }

  _getBusinessListInfo() {
    const menu = (
      <WizMenu onClick={this.handleMenuClick.bind(this)}>
        {/* <WizItem key="5">
          内容知识
        </WizItem>
        <WizItem key="4">
          学习资料
        </WizItem>
        <WizItem key="3">
          短视频
        </WizItem>
        <WizItem key="2">
          话术
        </WizItem> */}
        <WizItem key="1">
          在线课程
        </WizItem>
      </WizMenu>
    );
    let columns = [
      {
        title: "业务类型",
        name: "typeStr",
        dataIndex: "typeStr",
        tableItem: {},
      },
      {
        title: "业务名称",
        name: "entityName",
        dataIndex: "entityName",
        tableItem: {},
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 200,
        tableItem: {
          render: (text, record) => {
            return <span>
               <a onClick={e => this.props.moveUpAndDown({...record,type:'up'})} disabled={record.sort==1}> 上移</a>
               <Divider type="vertical" />
               <a onClick={e => this.props.moveUpAndDown({...record,type:'down'})} disabled={record.sort==this.props.businessListInfo.length} > 下移</a>
               <Divider type="vertical" />
               <a onClick={e => this.props.onLook(record) } disabled={!this.initialValue.id}>查看</a>
               <Divider type="vertical" />
               <a onClick={e => this.props.deleteRow(record)}>删除</a>
             </span>
           },
        },
      },
    ]
    const dataItems = getPageData({records:this.props.businessListInfo});
    const dataTableProps = {key:'businessList_dataTable1', columns: columns, rowKey: 'id', dataItems,loading:this.props.proKnowledgeLoading,style:{marginTop:'15px'} }

    return <WizSpin tip={'加载中'} spinning={this.props.proKnowledgeLoading}>
      <WizDropdown overlay={menu} >
          <WizButton >
            新增关联业务 <WizIcon type="down" />
          </WizButton>
        </WizDropdown>
        <WizDataTable {...dataTableProps} />
      {/* <WizTable loading={this.props.proKnowledgeLoading} key={'businessList_dataTable1'} style={{marginTop:'15px'}} pagination={false} columns={columns} dataSource={this.props.businessListInfo}/> */}
      {this._getModalInfo()}
    </WizSpin>
  }

  _changeTab = (key) => {
    this.setState({ activeKey: key })
    if(key === '2'){
     // this.props.getVersionList()
    }else if(key === '3'){
     // this.props.getChangeList()
    }else if(key === '4'){
     // this.props.getBusinessList()
    }
  }

  _getTabs() {
    const { proKnowledgeTypeInfo } = this.props
    let contentType = proKnowledgeTypeInfo.contentType;
    let businessListInfo = undefined
    if (contentType && contentType.indexOf("3") != -1) {
      businessListInfo = <TabPane tab="关联业务" key="4" >
      {this._getBusinessListInfo()}
    </TabPane>
    }
    return <WizTabs activeKey={this.state.activeKey}  onChange={(e) => this._changeTab(e)} animated={false}>
      <TabPane tab="高级设置" key="1" >
        {this._highSet()}
      </TabPane>
      {businessListInfo}
      <TabPane tab="版本" key="2" >
        {this._getVersionListInfo()}
      </TabPane>
      <TabPane tab="变更记录" key="3" >
        {this._getChangeListInfo()}
      </TabPane>
    </WizTabs>
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { title } = this.props;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    let cardProps = {
      headStyle: {backgroundColor: '#ffffff', color: '#3a3a3a'},
      bordered: true,
      bodyStyle: {minHeight: '850px'}
    }
    return (
        <WizForm
          {...formItemLayout}
        >
           <div className='knowledge-info'>
          {this._getHeader()}
          <WizRow className='knowledge-div-row' gutter={[8, 16]}>
            <WizCol span="8" className='knowledge-col'>
            <WizCard {...cardProps} className='left-box'>
                {this._getLeftBody()}
              </WizCard>
            </WizCol>
            <WizCol  span={16} className='knowledge-col'>
            <WizCard {...cardProps} >
              {this._getRightBody()}
              {this._getTabs()}
              </WizCard>
            </WizCol>
          </WizRow>
          </div>
        </WizForm>
    )

  }
}

export default WizForm.create()(KnowledgeBaseForm);


